import { parseDataByType } from "../../../utils";




const processDataDetailsForKendoGrid: any = (resData: any) => {
    try {
        if (!resData?.caseSummaryDataRows || !resData?.caseSummaryDataColumns) {
            return {
                gridColumns: [],
                gridRows: [],
                emptyMessage: "No records were found..",
                rowCount: 0,
                summary: null
            };
        }

        let processedData: any = [];

        if (resData.caseSummaryDataRows.length > 0) {
            resData.caseSummaryDataRows.forEach((res: any, index: number) => {
                let obj: any = {};

                resData.caseSummaryDataColumns.map((col: any, colIndex: number) => {
                    if (res && col?.name && res.values[colIndex]) {
                        obj[col.name.trim()] = parseDataByType(res.values[colIndex], col.dataType);
                    }
                });

                processedData.push(obj);
            });
        }

        const tmp = {
            ...resData,
            gridColumns: resData.caseSummaryDataColumns,
            gridRows: processedData,
            emptyMessage: "No records were found..",
            rowCount: processedData.length,
            summary: resData.summary
        }

        return tmp;
    } catch (e) {
        console.error(e);
        // Return empty state in case of error
        return {
            gridColumns: [],
            gridRows: [],
            emptyMessage: "An error occurred while processing data.",
            rowCount: 0,
            summary: null
        };
    }
}



export default { processDataDetailsForKendoGrid }